const welcome = {
    title: '관리자 콘솔에 오신 것을 환영해요',
    description: '관리자 콘솔를 통해 프로그래밍 없이 Logto를 관리할 수 있어요. 새로 계정을 생성하고, Logto를 당신의 회사에 알맞게 수정해 보세요.',
    create_account: '계정 생성',
};
export default Object.freeze(welcome);
